export class RiderDto {
    email:string;
    activeStatus:boolean;
}
